module.exports = __webpack_public_path__ + "static/img/1719.d08be73.png";